import React from "react";
import { Route, Redirect } from "react-router-dom";

import ParentDashboard from "../pages/parentDashboard/ParentDashboard"
import ChildDashboard from "../pages/childDashboard/ChildDashboard"
import TeacherDashboard from "../pages/teacherDashboard/TeacherDashboard"


function Dashboard({ ...rest }) {

    const isAuthenticated = localStorage.getItem('authToken')
    const role = localStorage.getItem('role')

    if (role == 1 && isAuthenticated)
        return <Route component={ParentDashboard} />
    else if (role == 2 && isAuthenticated)
        return <Route component={TeacherDashboard} />
    else if (role == 3 && isAuthenticated)
        return <Route component={ChildDashboard} />
    else if (role == 4 && isAuthenticated)
        return <Route component={ChildDashboard} />
    else
        return <Redirect to="/" />
};

export default Dashboard;